/**
 * Synchronize interaction events in:
 * mbs-web#Admin\Iframe\IframeInteractionEvent.cs
 * mbs-web#Scripts\iframeUtils.js
 */
export enum InteractionEvent {
  IFRAME_SIDEPANEL_OPEN = 'IFRAME_SIDEPANEL_OPEN',
  IFRAME_SIDEPANEL_CLOSE = 'IFRAME_SIDEPANEL_CLOSE',
  PARENT_SIDEPANEL_OPEN = 'PARENT_SIDEPANEL_OPEN',
  PARENT_SIDEPANEL_CLOSE_START = 'PARENT_SIDEPANEL_CLOSE_START',
  PARENT_SIDEPANEL_CLOSE_END = 'PARENT_SIDEPANEL_CLOSE_END',
  IFRAME_IN_IFRAME = 'IFRAME_IN_IFRAME',
  REFRESH_CURRENT_USER = 'REFRESH_CURRENT_USER',
  TOAST_SHOW = 'TOAST_SHOW',
  /* If you have some global function in iframe, then you can try to call it with custom arguments. */
  CALL_GLOBAL_FUNCTION_IN_IFRAME = 'CALL_GLOBAL_FUNCTION_IN_IFRAME',
  ERROR_MODAL_OPEN = 'ERROR_MODAL_OPEN',
  BACKUP_SIDEPANEL_OPEN = 'BACKUP_SIDEPANEL_OPEN'
}
